import React, { useState } from "react";
import { MapPin } from "lucide-react";

// Only the Daily copy is in the design; Weekly and Long-Term are drafts
const DURATIONS = [
  {
    key: "daily",
    label: "Daily",
    title: "Daily Rental",
    description:
      "Perfect for short trips, same-day travel and one-off journeys. Pick up and drop off on your schedule.",
  },
  {
    key: "weekly",
    label: "Weekly",
    title: "Weekly Rental",
    description: "Ideal for week-long assignments and business trips. One booking covers the whole of your visit.",
  },
  {
    key: "long-term",
    label: "Long-Term",
    title: "Long-Term Rental",
    description: "For extended stays, relocations and ongoing projects. Keep a vehicle for as long as you need it.",
  },
];

export function MoveDurations() {
  const [active, setActive] = useState(DURATIONS[0].key);
  const current = DURATIONS.find(d => d.key === active) || DURATIONS[0];

  return (
    <section className="bg-[#f5f8ff] py-20">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-16 px-[16px] sm:px-8 lg:grid-cols-2">
        <div>
          <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">Flexibility</p>
          <h2 className="pt-[12px] text-[30px] font-bold leading-10 tracking-[-0.9px] text-[#0a0a0a] sm:text-[36px]">
            Rent for as Long as You Need
          </h2>
          <p className="pt-[20px] text-[18px] leading-[29.25px] text-[#717182]">
            Whether it's a day trip, a week-long assignment or an extended stay, SPACIA MOVE gives you rental options
            that match your journey.
          </p>

          <div className="flex flex-wrap gap-[12px] pt-8" role="tablist">
            {DURATIONS.map(duration => (
              <button
                key={duration.key}
                type="button"
                role="tab"
                aria-selected={active === duration.key}
                onClick={() => setActive(duration.key)}
                className={`rounded-2xl px-6 py-[12px] text-[14px] font-semibold leading-5 transition-colors ${
                  active === duration.key
                    ? "bg-[#017bef] text-white drop-shadow-[0_2px_8px_rgba(1,123,239,0.25)]"
                    : "border-[1px] border-solid border-[#e5e7eb] bg-white text-[#717182] hover:text-[#0a0a0a]"
                }`}
              >
                {duration.label}
              </button>
            ))}
          </div>

          <div className="mt-8 rounded-2xl border-[1px] border-solid border-[#e5e7eb] bg-white p-6">
            <p className="text-[16px] font-bold leading-6 text-[#0a0a0a]">{current.title}</p>
            <p className="pt-2 text-[14px] leading-[22.75px] text-[#717182]">{current.description}</p>
          </div>
        </div>

        <img
          src="/figma-assets/move/flexibility.jpg"
          alt="Car driving through an archway"
          className="h-[360px] w-full rounded-3xl object-cover sm:h-[492px]"
        />
      </div>
    </section>
  );
}

const STOPS = [
  { title: "Airport", description: "Pickup point", color: "#717182" },
  { title: "Hotel", description: "Drop to accommodation", color: "#017bef" },
  { title: "Workspace", description: "Collect again", color: "#0062c0" },
  { title: "Different Drop-off", description: "Leave it here", color: "#0ea5e9" },
];

export function MovePickup() {
  return (
    <section className="bg-white py-20">
      <div className="mx-auto flex max-w-[1440px] flex-col items-center px-[16px] text-center sm:px-8">
        <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">Flexibility</p>
        <h2 className="pt-[12px] text-[30px] font-bold leading-10 tracking-[-0.9px] text-[#0a0a0a] sm:text-[36px]">
          Pick Up Where You Need It
        </h2>
        <p className="max-w-[512px] pt-[16px] text-[18px] leading-7 text-[#717182]">
          Your journey doesn't have to start and end in the same place.
        </p>

        <div className="grid w-full max-w-[896px] grid-cols-2 gap-[16px] pt-14 lg:grid-cols-4">
          {STOPS.map((stop, index) => (
            <div key={stop.title} className="relative">
              {/* Dashed link to the next card (desktop only) */}
              {index < STOPS.length - 1 && (
                <div className="absolute left-full top-[24px] hidden w-[16px] border-t-2 border-dashed border-[#e5e7eb] lg:block" />
              )}
              <div className="flex flex-col items-center rounded-2xl border-[1px] border-solid border-[#e5e7eb] bg-[#f8fbff] p-[20px]">
                <span
                  className="flex size-10 items-center justify-center rounded-full"
                  style={{ backgroundColor: `${stop.color}14` }}
                >
                  <MapPin className="size-4" style={{ color: stop.color }} />
                </span>
                <p className="pt-[12px] text-[14px] font-bold leading-5 text-[#0a0a0a]">{stop.title}</p>
                <p className="pt-1 text-[12px] leading-4 text-[#717182]">{stop.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
